import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import WarningIcon from '@nokia-csf-uxr/ccfk-assets/WarningIcon';
import { IconProps } from 'components/Icon';
import { getContext } from 'common';
import { StepContext, HorizontalStepContext, TriangleUnderlaySvg } from 'components/StepForm';

import Styled, { ICON_SIZE } from './styles';

const INDICATOR_STYLE = {
  border: 'none',
  background: 'transparent',
};
const TRIANGLE_UNDERLAY_STYLE = {
  top: '5%',
  left: '42%',
  transform: 'translate(-42%, -11%)',
};

export interface StepWarningIndicatorProps {
  /** To override the default WarningIcon.  */
  icon?: React.ReactNode;
  /** Apply properties to the default Icon. */
  iconProps?: Partial<IconProps>;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
  /** @ignore */
  style?: React.CSSProperties;
}

/** `StepWarningIndicator`, all other props will be provided to the wrapper. */
const StepWarningIndicator = React.forwardRef<HTMLElement, StepWarningIndicatorProps>((props, ref) => getContext(({ theme }) => {
  const { icon, iconProps, theme: themeProp, style: propStyle, ...otherProps } = props;
  const stepContext = useContext(StepContext);
  const horizontalStepContext = useContext(HorizontalStepContext);
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM || themeProp);
  const resolvedStyle = { ...INDICATOR_STYLE, ...propStyle };

  const isDisabled = stepContext.disabled || horizontalStepContext.disabled;
  const indicatorColor = isDisabled ? resolvedTheme.BUTTON.warning.disabled : resolvedTheme.BUTTON.warning.background;

  return (
    <Styled.StepIndicator
      ref={ref}
      $theme={resolvedTheme}
      disabled={stepContext.disabled}
      style={resolvedStyle}
      {...otherProps}
    >
      <Styled.StepIndicatorInside style={{ zIndex: 1 }}> {/* to go over TriangleUnderLay */}
        {icon || <WarningIcon size={ICON_SIZE} color={indicatorColor} {...iconProps} />}
      </Styled.StepIndicatorInside>
      {!icon &&
        <Styled.StepIndicatorInside style={TRIANGLE_UNDERLAY_STYLE}>
          <TriangleUnderlaySvg theme={resolvedTheme} />
        </Styled.StepIndicatorInside>
      }
    </Styled.StepIndicator>
  );
}));

StepWarningIndicator.defaultProps = {
  icon: undefined,
  iconProps: {},
  theme: {},
  style: {}
};

StepWarningIndicator.displayName = 'StepWarningIndicator';

export default StepWarningIndicator;